import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useUserStore = defineStore('user', {
  state: () => ({
    users: [],
    selectedUserIds: [],
    editUserId: null,

    usertypes: [],
    selectedUsertype: null,
    sortedBy: {
      column: 'username',
      desc: false,
    },
  }),
  getters: {
    getUsers: function(state) {
      return state.users;
    },
    getEditUser: function(state) {
      return state.users.find(x => x.id === state.editUserId);
    },
    getSelectedUsers: function(state) {
      return state.users.filter(x => state.selectedUserIds.indexOf(x.id) >= 0);
    },
    getUsertypes: function(state) {
      return state.usertypes;
    },
    getSortedBy: function(state) {
      return state.sortedBy;
    }
  },
  actions: {
    // _addUser: function(user) {
    //   this.users.push(user);
    // },
    _updateUser: function(user) {
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id == user.id) {
          Object.assign(this.users[i], user);
          break;
        }
      }
    },
    // _removeUser: function(user) {
    //   if (this.editUserId && user.id === this.editUserId) {
    //     this.editUserId = null;
    //   }

    //   const userIndex = this.users.indexOf(user);
    //   if (userIndex >= 0) {
    //     this.users.splice(userIndex, 1);
    //   }

    //   this.selectedUserIds = this.selectedUserIds.filter(x => x !== user.id);
    // },
    toggleSelection: function(user) {
      let index = this.selectedUserIds.indexOf(user.id);

      if (index >= 0) {
        this.selectedUserIds.splice(index, 1);
      } else {
        this.selectedUserIds.push(user.id);
      }
    },
    resetSelectedUsers: function() {
      this.selectedUserIds = [];
    },
    resetUsers: function() {
      this.users = [];
      this.originUsers = [];
      this.selectedUserIds = [];
    },


    refreshUsertypes: async function() {
      try {
        const result_1 = await Api.user.getUsertypes();
        this.usertypes = result_1.data;
      } catch (error) {
        console.error("Error getting usertypes!", error);
      }
    },
    refreshUsers: async function(payload) {
      try {
        const result = await Api.user.getAllUsers(payload);
        this.users = result.data;

        // filter out the selected users that are not present in the new users array
        this.selectedUserIds = this.selectedUserIds.filter(function(userId) {
          return !!this.users.find(y => y.id === userId);
        });

        return this.users;
      } catch (error) {
        console.error("Error getting users!", error);
      }
    },
    setEditUser: function(user) {
      this.editUserId = (user && user.id) ? user.id : null;
    },
    getUser: async function(userId) {
      const result = await Api.user.getUser(userId);
      return result.data;
    },
    createUser: async function(formData) {
      const result = await Api.user.createUser(formData);
      return result.data;
    },
    updateUser: async function(formData) {
      const result = await Api.user.updateUser(formData);
      // update the user in the users lists (including selectedUsers)
      this._updateUser(result.data);
      return result.data;
    },
    deleteUser: async function(payload) {
      const result = await Api.user.deleteUser(payload);
      return result.data;
    },
    detachUser: async function(payload) {
      const result = await Api.user.detachUser(payload);
      return result.data;
    },
    savePermissions: async function(payload) {
      const result = await Api.user.savePermissions(payload);
        this._updateUser(result.data);
        return result.data;
    },
    addAccesspoint: async function(payload) {
      const result = await Api.user.addAccesspoint(payload.userid, payload.nodeid);
      return result.data;
    },
    deleteAccesspoint: async function(payload) {
      const result = await Api.user.deleteAccesspoint(payload.userid, payload.nodeid);
      return result.data;
    },
    updateAccesspoint: async function(payload) {
      const result = await Api.user.updateAccesspoint(payload);
      return result.data;
    },
    changeRootNode: async function(payload) {
      const result = await Api.user.changeRootNode(payload.nodeid, payload.users);
      return result.data;
    },
    toggleDisabledUsers: function() {
      this._toggleDisabledUsers();
    },
    pingUser: async function(payload) {
      const response = await Api.user.pingUser(payload);
      console.log('response', response);
      return response.data;
    },
    updatePassword: async function(payload) {
      const response = await Api.user.updatePassword(payload);
      return response.data;
    },
    sendTemporaryPasswordCode: async function(payload) {
      const response = await Api.user.sendTemporaryPasswordCode(payload);
      return response.data;
    },
    resetTemporaryPassword: async function(payload) {
      const response = await Api.user.resetTemporaryPassword(payload);
      return response.data;
    }
  },
});
